const HEX = /^#[0-9a-fA-F]{6}$/;

function channel(v: number): number {
  const s = v / 255;
  return s <= 0.03928 ? s / 12.92 : Math.pow((s + 0.055) / 1.055, 2.4);
}

/** Relative luminance (WCAG) of a #rrggbb colour. */
export function luminance(hex: string): number {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return 0.2126 * channel(r) + 0.7152 * channel(g) + 0.0722 * channel(b);
}

/** Black or white, whichever reads better on the given background. */
export function readableOn(hex: string): string {
  if (!HEX.test(hex)) return '#ffffff';
  return luminance(hex) > 0.4 ? '#111827' : '#ffffff';
}

export interface BrandColours {
  primaryColour: string;
  accentColour: string;
}

export function brandStyle(b: BrandColours): Record<string, string> {
  const primary = HEX.test(b.primaryColour) ? b.primaryColour : '#2563eb';
  const accent = HEX.test(b.accentColour) ? b.accentColour : '#f2a900';
  return {
    '--brand-primary': primary,
    '--brand-accent': accent,
    '--brand-on-primary': readableOn(primary),
  };
}

/** Apply the colours to the whole document (header, buttons, focus ring). */
export function applyBranding(b: BrandColours | null): void {
  const root = document.documentElement;
  const vars = brandStyle(b ?? { primaryColour: '', accentColour: '' });
  for (const [k, v] of Object.entries(vars)) root.style.setProperty(k, v);
}
